/*************************************
 *
 * 与 Android 和 IOS 交互插件
 * Author:smallsix@66629
 *
 *************************************/

/**
 * 封装 WebViewJavascriptBridge
 * 用于与安卓 和 iOS 交互
 *
 * @param callback
 * @returns {number|*}
 */
import {isWebView} from '../../utils/customUtils'

function setupWebViewJavascriptBridge (callback) {
  // android使用
  if (!window.WebViewJavascriptBridge) {
    document.addEventListener(
      'WebViewJavascriptBridgeReady'
      , () => {
        callback(window.WebViewJavascriptBridge)
      },
      false
    )
  }

  if (window.WebViewJavascriptBridge) return callback(window.WebViewJavascriptBridge)
  if (window.WVJBCallbacks) return window.WVJBCallbacks.push(callback)

  window.WVJBCallbacks = [callback]
  let WVJBIframe = document.createElement('iframe')
  WVJBIframe.style.display = 'none'
  WVJBIframe.src = 'https://__bridge_loaded__'
  document.documentElement.appendChild(WVJBIframe)

  setTimeout(() => {
    document.documentElement.removeChild(WVJBIframe)
  }, 0)
}

/**
 * 初始化 WebViewJavascriptBridge
 * 解决 安卓调用 JS 方法无效
 */

const sixBridge = {}
if (isWebView()) { // 仅在webview的环境下执行
  setupWebViewJavascriptBridge((bridge) => {
    bridge.init(function (message, responseCallback) {
      let data = {}
      if (responseCallback) {
        responseCallback(data)
      }
    })
  })
  sixBridge.install = (Vue) => {
    Vue.prototype.$sixBridge = {
      callhandler (name, data, callback) {
        setupWebViewJavascriptBridge((bridge) => {
          bridge.callHandler(name, data, callback)
        })
      },
      registerhandler (name, callback) {
        setupWebViewJavascriptBridge((bridge) => {
          bridge.registerHandler(name, function (data, responseCallback) {
            callback(data, responseCallback)
          })
        })
      }
    }
  }
}
// todo 之后测试成功即可删除
// setupWebViewJavascriptBridge((bridge) => {
//   bridge.init(function (message, responseCallback) {
//     let data = {}
//     if (responseCallback) {
//       responseCallback(data)
//     }
//   })
// })
//
// const sixBridge = {}
// sixBridge.install = (Vue) => {
//   Vue.prototype.$sixBridge = {
//     callhandler (name, data, callback) {
//       setupWebViewJavascriptBridge((bridge) => {
//         bridge.callHandler(name, data, callback)
//       })
//     },
//     registerhandler (name, callback) {
//       setupWebViewJavascriptBridge((bridge) => {
//         bridge.registerHandler(name, function (data, responseCallback) {
//           callback(data, responseCallback)
//         })
//       })
//     }
//   }
// }

export default sixBridge



// WEBPACK FOOTER //
// ./src/plugins/sixBridge/index.js